import React, { useState, useEffect } from 'react';
import { getCibilEligibilityByLoanId, savecibilEligibilitycheckByData } from '../../../AdminActionCreator.component';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../../presentationals/Popup/Popup.component'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { CheckFunction } from '../../../../../../layouts/MainTenantconfig';

const CIBILEligibilityForm = ({ allDetail }) => {
  const tenant = CheckFunction();
  const [apiUserId, setApiUserId] = useState("")
  const [pageType, setPageType] = useState("admin")
  const [userLoanId, setUserLoanId] = useState("")
  const [view, setView] = useState("list");
  const [loader, setLoader] = useState(false)
  const [popup, setPopup] = useState({ show: false, popupStatus: "" })
  const [apiData, setAPiData] = useState({})
  const [formData, setFormData] = useState({
    loginDocuments: '',
    duplicateLoanCheck: '',
    addressCheck: '',
    // rentedAddressUpdated: false,
    ageEligibility: '',
    coBorrowerDetails: '',
    // coBorrowerChange: '',
    batterySerialNumber: '',
    hpStatus: '',
    cibilScore: '',
    cibilReport: "",
    caseApprovedByTeam: '',
    caseApprovedByDeviation: '',
    pendencyClearance: '',
    whatsappNotification: ""
  });

  const isDisabled = view === "list";

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      "userId": apiUserId,
      "loanId": userLoanId,
      "loginDocumentVerification": formData?.loginDocuments,
      "duplicateLoanCheck": formData?.duplicateLoanCheck,
      "addressCheck": formData?.addressCheck,
      "ageCheck": formData?.ageEligibility,
      "coBorrowerCheck": formData?.coBorrowerDetails,
      "batterySerialCheck": formData?.batterySerialNumber,
      "hpStatusCheck": formData?.hpStatus,
      "cibilScore": formData?.cibilScore,
      "cibilReport": formData?.cibilReport,
      "caseApproveStatusByTeam": formData?.caseApprovedByTeam,
      "caseApproveStatusByDeviation": formData?.caseApprovedByDeviation,
      "pendencyAndRejectionDetail": formData?.pendencyClearance,
      "whatsappNotification": formData?.whatsappNotification
    }
    setLoader(true)
    const obj = { ...data }
    if (apiData?.id) {
      obj.id = apiData?.id
    }
    savecibilEligibilitycheckByData(obj, Callback => {
      setLoader(false)
      if (Callback?.message == "success" && Callback?.status) {
        setPopup({ show: true, popupStatus: 'Data Saved Successfully!' })
      } else {
        setPopup({ show: true, popupStatus: 'Error Saving Data' })
      }
      removePopup()
    })

    setView('list');
  };

  const handleClose = () => {
    setView('list');
  };

  const handleEdit = () => {
    setView('edit');
  };


  useEffect(() => {
    const fetchData = async () => {
      const id = await fetchLoanId()
      setUserLoanId(id)

      setLoader(true)
      getCibilEligibilityByLoanId(id, Callback => {
        setLoader(false)
        setAPiData(Callback?.data || {})
        setFormData({
          loginDocuments: Callback?.data?.loginDocumentVerification || '',
          duplicateLoanCheck: Callback?.data?.duplicateLoanCheck || '',
          addressCheck: Callback?.data?.addressCheck || '',
          // rentedAddressUpdated: false,
          ageEligibility: Callback?.data?.ageCheck || '',
          coBorrowerDetails: Callback?.data?.coBorrowerCheck || '',
          // coBorrowerChange: '',
          batterySerialNumber: Callback?.data?.batterySerialCheck || '',
          hpStatus: Callback?.data?.hpStatusCheck || '',
          cibilScore: Callback?.data?.cibilScore || '',
          cibilReport: Callback?.data?.cibilReport || "",
          caseApprovedByTeam: Callback?.data?.caseApproveStatusByTeam || '',
          caseApprovedByDeviation: Callback?.data?.caseApproveStatusByDeviation || '',
          pendencyClearance: Callback?.data?.pendencyAndRejectionDetail || '',
          whatsappNotification: Callback?.data?.whatsappNotification || ""
        })
      })
    }
    fetchData()
  }, [])

  const closePopup = () => {
    setPopup({ show: false, popupStatus: "" })
  }

  const removePopup = () => {
    setTimeout(() => {
      closePopup()
    }, 5000)
  }

  const fetchLoanId = () => {
    const url = window.location.pathname;
    if (url == "/adminlogin" || url == "/adminLogin") {
      setPageType("admin")
      setApiUserId(allDetail?.userId)
      return allDetail?.loanId
    } else if (url?.includes('/loanCheck/')) {
      setPageType("link")
      const loanid = url?.split('/loanCheck/')?.[1]
      const [ finalloanId, finalUserId ] = loanid?.split("/")
      setApiUserId(finalUserId)
      return finalloanId
    }

  }

  return (
    <>
      {
        loader ? <Loader /> : ""
      }
      {
        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
      }
      {
        pageType == "link" ?
          <div className="container-fluid">
            <div className="row">
              <div className="">
                <div style={{ position: 'fixed', top: 0, backgroundColor: '#fff', zIndex: 1000, padding: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', textAlign: 'right' }}>
                  <img src={tenant?.LOGO} style={{ marginTop: '20px', marginLeft: '20px', width: '10%', maxWidth: '103px', float: 'left' }} />
                </div>
              </div>
            </div>
          </div>
          : ""}
      <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif', backgroundColor: '#f5f5f5', borderRadius: '8px', padding: '20px', marginTop: pageType == "link" ? "100px" : "50px" }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <div style={{ padding: '24px', borderBottom: '1px solid #e5e5e5', position: 'sticky', top: pageType == "link" ? "" : '130px', background: '#ffff', borderTopLeftRadius: '8px', borderTopRightRadius: "8px", zIndex: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600' }}>
                  {view === "list" ? "View CIBIL & Eligibility Details" : "Update CIBIL & Eligibility Details"}
                </h2>
              </div>
              <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                {
                  // pageType == "link" ? "" :
                  view === "list" ?
                    (
                      <>

                        <button
                          type="button"
                          onClick={handleEdit}
                          style={{ padding: '12px 32px', backgroundColor: '#1e40af', color: 'white', border: 'none', borderRadius: '6px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                          onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a8a'}
                          onMouseOut={(e) => e.target.style.backgroundColor = '#1e40af'}
                        >
                          Edit
                        </button>
                        {
                          pageType == "link" ? "" :
                            <button
                              type="button"
                              onClick={() => window.open(tenant?.FRONTEND_BASE_URL + "loanCheck/" + userLoanId + "/" + apiUserId, "_blank")}
                              style={{ padding: '10px 32px', backgroundColor: '#1e40af', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                              onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a8a'}
                              onMouseOut={(e) => e.target.style.backgroundColor = '#1e40af'}
                            >
                              <OpenInNewIcon style={{ fontSize: '18px' }} />
                            </button>
                        }
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          onClick={handleClose}
                          style={{ padding: '12px 32px', backgroundColor: 'white', color: '#374151', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                          onMouseOver={(e) => e.target.style.backgroundColor = '#f9fafb'}
                          onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={handleSubmit}
                          style={{ padding: '12px 32px', backgroundColor: '#1e40af', color: 'white', border: 'none', borderRadius: '6px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                          onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a8a'}
                          onMouseOut={(e) => e.target.style.backgroundColor = '#1e40af'}
                        >
                          Save and Continue
                        </button>
                      </>
                    )}
              </div>
            </div>
          </div>

          <div style={{ padding: '32px', overflowY: 'auto', height: pageType == "link" ? "" : '400px' }}>
            {/* Section 1: Login Documents Verification */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>1. Login Documents Verification</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Login Documents Status <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="loginDocuments"
                    value={formData.loginDocuments}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="VERIFIED">Verfied</option>
                    <option value="NOT_VERIFIED">Not Verfied</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Section 2: Duplicate Loan Request Check */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>2. Duplicate Loan Request Check</h3>
              <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '20px' }}>(by Aadhaar, PAN, 2nd ID, or Mobile Number)</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Duplicate Loan Check <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="duplicateLoanCheck"
                    value={formData.duplicateLoanCheck}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="DUPLICATE_FOUND">Duplicate Found</option>
                    <option value="NO_DUPLICATE_FOUND">No Duplicate Found</option>
                  </select>
                </div>

              </div>
            </div>

            {/* Section 3: Address Check */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>3. Address Check</h3>
              <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '20px' }}>(by Aadhaar)</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Address Check <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="addressCheck"
                    value={formData.addressCheck}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="FOUND">Match</option>
                    <option value="NOT_FOUND">Not Match</option>
                  </select>
                </div>
                {/* {formData.addressCheck === 'not-match' && (
                  <div>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: isDisabled ? 'not-allowed' : 'pointer' }}>
                      <input
                        type="checkbox"
                        name="rentedAddressUpdated"
                        checked={formData.rentedAddressUpdated}
                        onChange={handleChange}
                        disabled={isDisabled}
                        style={{ width: '18px', height: '18px', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                      />
                      <span style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>Rented Address Updated</span>
                    </label>
                  </div>
                )} */}
              </div>
            </div>

            {/* Section 4: Age Eligibility */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>4. Age Eligibility Check</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Age Eligibility <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="ageEligibility"
                    value={formData.ageEligibility}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="PASS">Pass</option>
                    <option value="FAIL">Fail</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Section 5: Co-Borrower Check */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>5. Co-Borrower Check</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Co-Borrower Details <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="coBorrowerDetails"
                    value={formData.coBorrowerDetails}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="VALID">OK</option>
                    <option value="NOT_VALID">Not OK</option>
                    <option value="change-required">Change Required</option>
                    <option value="not-required">Not Required</option>
                  </select>
                </div>

              </div>
            </div>

            {/* Section 6: Battery Serial Number Check */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>6. Battery Serial Number Check</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Battery Serial Number Status <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="batterySerialNumber"
                    value={formData.batterySerialNumber}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="new">New</option>
                    <option value="duplicate">Duplicate</option>
                    <option value="old-refinance">Old (Re-finance)</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Section 7: HP Status */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>7. HP Status</h3>
              <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '20px' }}>(from Vahan Registration Number)</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    HP Status <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="hpStatus"
                    value={formData.hpStatus}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="hp">HP</option>
                    <option value="cash">Cash</option>
                    <option value="tenure-complete">Tenure Complete by HP</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Section 8: CIBIL Score */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>8. CIBIL Score</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    CIBIL Score  <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    name="cibilScore"
                    type='text'
                    value={formData.cibilScore}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  />

                </div>
              </div>
            </div>

            {/* Section 9: CIBIL Report */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>9. CIBIL Report</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    {/* Upload CIBIL Report */}
                    CIBIL Report
                  </label>
                  <input
                    type="text"
                    name="cibilReport"
                    onChange={handleChange}
                    disabled={isDisabled}
                    // accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  />
                  {/* {formData.cibilReport && (
                    <p style={{ marginTop: '8px', fontSize: '13px', color: '#6b7280' }}>
                      Selected: {formData.cibilReport.name}
                    </p>
                  )} */}
                </div>
              </div>
            </div>

            {/* Section 10: Case Approved Status */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>10. Case Approved Status</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    By TEAM <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="caseApprovedByTeam"
                    value={formData.caseApprovedByTeam}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="REJECTED">Reject</option>
                    <option value="APPROVED">Approve</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    By Deviation (if rejected by TEAM)
                  </label>
                  <select
                    name="caseApprovedByDeviation"
                    value={formData.caseApprovedByDeviation}
                    onChange={handleChange}
                    disabled={isDisabled}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: (isDisabled) ? '#f9fafb' : 'white', cursor: (isDisabled) ? 'not-allowed' : 'pointer' }}
                  >
                    <option value="">Select</option>
                    <option value="REJECTED">Reject</option>
                    <option value="APPROVED">Approve</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Section 11: Pendency and Rejection Details */}
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>11. Pendency and Rejection Details</h3>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                  Pendency Clearance (Required by Dealer)
                </label>
                <textarea
                  name="pendencyClearance"
                  value={formData.pendencyClearance}
                  onChange={handleChange}
                  disabled={isDisabled}
                  rows="4"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: isDisabled ? '#f9fafb' : 'white', cursor: isDisabled ? 'not-allowed' : 'text', resize: 'vertical' }}
                  placeholder="Enter pendency clearance details..."
                />
              </div>


              <h4 style={{ fontSize: '16px', fontWeight: '600', marginTop: '24px', marginBottom: '16px', color: '#374151' }}>
                WhatsApp Notifications
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <select
                  name="whatsappNotification"
                  value={formData.whatsappNotification}
                  onChange={handleChange}
                  disabled={isDisabled}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: (isDisabled) ? '#f9fafb' : 'white', cursor: (isDisabled) ? 'not-allowed' : 'pointer' }}
                >
                  <option value="">Select</option>
                  <option value="Pendency Remarks Sent">Pendency Remarks Sent</option>
                  <option value="Rejection Reason Sent">Rejection Reason Sent</option>
                  <option value="Approval Message Sent">Approval Message Sent</option>
                </select>


              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CIBILEligibilityForm;